<template>
  <div class="data">
    <div class="data-inner">
      <div class="data-head">
        <div>统计数据展示</div>
      </div>
      <div class="data-con">
        <div class="flex flex-row">
          <div class="map" id="mapChart">dd</div>
          <div class="flex-1">
            <OnlineNum
              :data="publishedDevices"
              title="已发布设备"
              :bg="$oss('images/home/mapData/device.png')"
            />
            <OnlineNum
              :data="onlineAbility"
              title="已上线能力"
              :bg="$oss('images/home/mapData/ability.png')"
            />
          </div>
        </div>
        <CheckAbility />
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts/map/js/china";
import Regions from "./regions";
import CheckAbility from "./components/CheckAbility";
// import DeviceRank from "./components/DeviceRank.vue";
import OnlineNum from "./components/OnlineNum.vue";
import { PROVICES, PROVICESTEXT } from "./config";
import { mapData, deviceAndAbilityCount } from "@/api/home";
export default {
  name: "modular_data_show",
  components: {
    OnlineNum,
    CheckAbility,
    // DeviceRank,
  },
  data() {
    return {
      chart: null,
      regions: Regions,
      publishedDevices: 0, // 已发布设备
      onlineAbility: 0, // 已上线能力
      provinces: PROVICES,
      provincesText: PROVICESTEXT,
    };
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  mounted() {
    this.initChart();
    this.getDeviceAbilityCount();
  },
  methods: {
    async getDeviceAbilityCount() {
      const res = await this.$axios.get(deviceAndAbilityCount);
      const { labAbilityCount, labDeviceCount } = res;
      this.onlineAbility = labAbilityCount;
      this.publishedDevices = labDeviceCount;
    },
    async initChart() {
      this.chart = echarts.init(document.getElementById("mapChart"));
      const car_data = await this.$axios.get(mapData);
      const option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            const { data, name } = params;
            return `${name}<br/>设备数：${data.value[2]}`;
          },
        },
        geo: {
          map: "china",
          show: true,
          // roam: true, //拖拽和伸缩
          zoom: 1.24,
          label: {
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            emphasis: {
              //鼠标放上去区域背景色
              areaColor: "#034DE4",
              opacity: 0.7,
            },
            normal: {
              borderWidth: 1, //边际线大小
              borderColor: "#99ccff", //边界线颜色
              areaColor: "#369EF8", //默认区域颜色
            },
          },
          // regions: this.regions, // 给每个省份的区域加上背景色
        },
        series: {
          type: "effectScatter",
          coordinateSystem: "geo",
          data: this.convertData(car_data),
          symbolSize: function (val) {
            //设置散点大小
            return val[2] / (val[2] / 10);
          },
          showEffectOn: "render", //配置何时显示特效。可选：'render' 绘制完成后显示特效
          rippleEffect: {
            //涟漪特效相关配置
            brushType: "stroke", //波纹的绘制方式，可选 'stroke' 和 'fill'
          },
          hoverAnimation: true, //是否开启鼠标 hover 的提示动画效果
          label: {
            //图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等，
            normal: {
              formatter: "{b}",
              position: "right",
              show: false,
            },
          },
          itemStyle: {
            //图形样式，normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式，比如在鼠标悬浮或者图例联动高亮时
            normal: {
              color: "#FEFA05", //散点的颜色
              shadowBlur: 10,
              shadowColor: 20,
              fontSize: "12px",
            },
          },
          zlevel: 1,
        },
      };
      this.chart.setOption(option);
      this.chart.on("click", function (param) {
        //遍历取到provincesText 中的下标  去拿到对应的省js
        const provincesText = this.provincesText;
        const provinces = this.provinces;
        for (var i = 0; i < provincesText.length; i++) {
          if (param.name == provincesText[i]) {
            //显示对应省份的方法
            this.showProvince(provinces[i], provincesText[i]);

            break;
          }
        }
      });
    },
    // 数据处理
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        const { labLatitude, labLongitude, regionName, deviceCount } = data[i];
        res.push({
          name: regionName,
          value: [labLongitude, labLatitude, deviceCount],
        });
      }
      return res;
    },
    showProvince() {},
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
@import "../../common.scss";
.map {
  width: 65%;
  height: 500px;
}
.data {
  &-inner {
    width: $max-width;
    margin: 0 auto;
    padding-top: 32px;
    padding-bottom: 20px;
  }
  &-head {
    border-bottom: 1px solid #e9e9e9;
    font-size: 18px;
    color: $theme-color;
    font-weight: bold;
    > div {
      padding: 10px 0px;
      display: inline-block;
      border-bottom: 2px solid $theme-color;
    }
  }
  &-con {
    padding-top: 20px;
    min-height: 400px;
    background: linear-gradient(
      360deg,
      rgba(253, 241, 251, 0) 0%,
      rgba(217, 242, 251, 0.47) 100%
    );
  }
}
</style>
